import { defineComponent as a, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "24f451c0-3ef3-4b2e-b0bd-256730c20625" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#24f451c0-3ef3-4b2e-b0bd-256730c20625)" }, p = { key: 0 }, v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M41.3 121.9 512 167v178L43.8 391.3z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M0 0h512v167H111z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M111 345h401v167H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0v512l256-256z"
}, null, -1), w = { fill: "none" }, b = ["r"], B = /* @__PURE__ */ a({
  __name: "ps",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), c("title", p, d(t.flagName), 1)) : _("", !0),
        v,
        k,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=ps-b1486836.js.map
